module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "md-fade-bottom"
    },
    on: {
      "after-leave": _vm.doDestroy
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPopper),
      expression: "showPopper"
    }],
    staticClass: "el-dropdown-menu"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-703b8f6f!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/dropdown/src/dropdown-menu.vue
// module id = 664
// module chunks = 0